// 
class ProductGridSwitcher extends HTMLElement {
  constructor() {
    super();

    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.layoutClasses = {
      '1': 'grid--1-col-desktop',
      '2': 'grid--2-col-desktop',
      '2-multi': 'multi-col'
    };
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.collection-view-btn');
    if (!this.buttons.length) return;

   // this.restoreLayout();

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', this.onButtonClick);
    });

    document.addEventListener('product-grid:updated', () => {
      this.applyLayout();
    });

    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) => {
      btn.removeEventListener('click', this.onButtonClick);
    });

    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.applyLayout();
  }

  onButtonClick(event) {
    // Don't change desktop layout
    if (window.innerWidth > 749) return;

    const btn = event.currentTarget;
    const layout = btn.dataset.layout;

   //localStorage.setItem('gridDesktop', layout);

    this.applyLayout();
    this.updateButtons(btn);
  }

  restoreLayout() {
    const savedLayout = localStorage.getItem('gridDesktop') || '2-multi';

    this.applyLayout();

    const activeBtn = this.querySelector(
      `.collection-view-btn[data-layout="${savedLayout}"]`
    );

    if (activeBtn) {
      this.updateButtons(activeBtn);
    }
  }

  applyLayout() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    // Remove previously applied classes
    [
      'grid--1-col-desktop',
      'grid--2-col-desktop',
      'grid--5-col-desktop',
      'multi-col'
    ].forEach((className) => {
      grid.classList.remove(className);
    });

    // Only apply custom layout on mobile/tablet
    if (window.innerWidth > 749) {
      return;
    }

    const layout = localStorage.getItem('gridDesktop') || '2-multi';

    if (layout === '2-multi') {
      grid.classList.add('grid--2-col-desktop', 'multi-col');
      return;
    }

    const activeClass = this.layoutClasses[layout];

    if (activeClass) {
      activeClass.split(' ').forEach((className) => {
        grid.classList.add(className);
      });
    }
  }

  updateButtons(activeBtn) {
    this.buttons.forEach((btn) => {
      const isActive = btn === activeBtn;

      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
}

customElements.define('product-grid-switcher', ProductGridSwitcher);
